
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0A1628] text-white">
      {/* Main Footer */}
      <div className="px-4 md:px-8 lg:px-16 py-12 md:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 lg:gap-12">
          {/* Column 1 - Brand */}
          <div className="col-span-1">
            <img 
              src="https://static.readdy.ai/image/2eafc1b8d0f8a30cd1652506171b568e/fd7c34e53328c1a9d4e2e619c5e8c0e1.jpeg"
              alt="Global Soccer Dreams"
              className="h-10 md:h-12 w-auto mb-4 md:mb-6"
            />
            <p className="text-base md:text-lg font-serif leading-relaxed text-gray-300">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Column 2 - Services */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">{t('footer.services')}</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/services#soccer" className="text-sm md:text-base text-gray-300 hover:text-[#C4FF0E] transition-colors cursor-pointer">
                  Global Soccer Dreams
                </Link>
              </li>
              <li>
                <a 
                  href="https://www.mira-closet.com" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm md:text-base text-gray-300 hover:text-[#C4FF0E] transition-colors cursor-pointer"
                >
                  Mira Closet
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Company */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">{t('footer.company')}</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/" className="text-sm md:text-base text-gray-300 hover:text-[#C4FF0E] transition-colors cursor-pointer">
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <Link to="/company" className="text-sm md:text-base text-gray-300 hover:text-[#C4FF0E] transition-colors cursor-pointer">
                  {t('footer.companyInfo')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm md:text-base text-gray-300 hover:text-[#C4FF0E] transition-colors cursor-pointer">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm md:text-base text-gray-300 hover:text-[#C4FF0E] transition-colors cursor-pointer">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-white/10 px-4 md:px-8 lg:px-16 py-6 md:py-8">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
          <p className="text-gray-400 text-xs md:text-sm font-serif text-center md:text-left">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-3 md:gap-4">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#C4FF0E] hover:text-[#0A1628] transition-all duration-300 cursor-pointer"
            >
              <i className="ri-instagram-line text-base md:text-lg"></i>
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#C4FF0E] hover:text-[#0A1628] transition-all duration-300 cursor-pointer"
            >
              <i className="ri-linkedin-line text-base md:text-lg"></i>
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-500 hover:text-[#C4FF0E] transition-colors cursor-pointer ml-2"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
